import { reduxForm } from 'redux-form';

import ConservatoryForm from './ConservatoryForm';
import SizeForm from './SizeForm';
import validate from './validate';
import TypeForm from './TypeForm';
import RoofForm from './RoofForm';
import ColourForm from './ColourForm';




export const Type = {
    name: 'Type',
    form: reduxForm({
        form: 'ConservatoryWizard',
        destroyOnUnmount: false,
        // forceUnregisterOnUnmount: true,
        keepDirtyOnReinitialize: true,
        enableReinitialize: true,
        validate
    })(ConservatoryForm)
};
export const Size = {
    name: 'Dimensions',
    form: SizeForm
};
export const Style = {
    name: 'Style',
    form: reduxForm({
        form: 'ConservatoryWizard',
        destroyOnUnmount: false,
        // forceUnregisterOnUnmount: true,
        keepDirtyOnReinitialize: true,
        enableReinitialize: true,
        validate
    })(TypeForm)
};
export const RoofMaterial = {
    name: 'Roof Material',
    form: reduxForm({
        form: 'ConservatoryWizard',
        destroyOnUnmount: false,
        // forceUnregisterOnUnmount: true,
        keepDirtyOnReinitialize: true,
        enableReinitialize: true,
        validate
    })(RoofForm)
};

export const Colour = {
    name: 'Colour',
    form: reduxForm({
        form: 'ConservatoryWizard',
        destroyOnUnmount: false,
        // forceUnregisterOnUnmount: true,
        keepDirtyOnReinitialize: true,
        enableReinitialize: true,
        validate
    })(ColourForm)
};

export const Summary = {
    name: 'Summary',
    form: reduxForm({
        form: 'ConservatoryWizard',
        destroyOnUnmount: false,
        // forceUnregisterOnUnmount: true,
        keepDirtyOnReinitialize: true,
        enableReinitialize: true,
        validate
    })(SizeForm)
};


// WEBPACK FOOTER //
// ./src/containers/ConservatoryForm/index.js